import { BookOpen, CreditCard, GraduationCap } from "lucide-react";

export const PARTNER_NAV = [
  { to: "/partner", label: "My students", icon: GraduationCap, end: true, testId: "nav-my-students" },
  { to: "/partner/plan", label: "Plan & billing", icon: CreditCard, testId: "nav-plan" },
  { to: "/partner/how-it-works", label: "How it works", icon: BookOpen, testId: "nav-how-it-works" },
];
